import { Box, Skeleton } from '@bonanza-social/moonlight';
import { memo } from 'react';

function CommunityJackpotWinnersSkeleton() {
  return (
    <Box paddingTop="space-400" gap="space-800">
      <Skeleton height={83} borderRadius="radius-400" />
      <Skeleton height={83} borderRadius="radius-400" />
      <Box gap="space-400">
        <Skeleton height={28} />
        <Box gap="space-200">
          <Skeleton height={26} />
          <Skeleton height={26} />
        </Box>
      </Box>
    </Box>
  );
}

export default memo(CommunityJackpotWinnersSkeleton);
